export default __webpack_public_path__ + "static/media/04-french-tulip.8b71fa3c.png";